export default "__VITE_ASSET__BBfALkHk__"